var methodCache = {};
/**
 * è·åè®¡ç® ticks çæ¹æ³
 * @param key é®å¼
 * @returns è®¡ç® ticks çæ¹æ³
 */
export function getTickMethod(key) {
    return methodCache[key];
}
/**
 * æ³¨åè®¡ç® ticks çæ¹æ³
 * @param key é®å¼
 * @param method æ¹æ³
 */
export function registerTickMethod(key, method) {
    methodCache[key] = method;
}
//# sourceMappingURL=register.js.map